import {UseCasesPage} from './UseCasesPage';
export default UseCasesPage;